import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LocalStorageService } from '../../../../../core/services/localStorage.service';

@Injectable({
  providedIn: 'root',
})
export class ListViewModeService {
  protected isCompact$ = new BehaviorSubject<boolean>(false);
  COMPACT_ROWS = 'CompactRows';

  constructor(private localStorageService: LocalStorageService) {}

  loadViewMode() {
    const viewMode = this.localStorageService.getItem(this.COMPACT_ROWS);
    this.isCompact$.next(viewMode === 'true');
  }

  setStatus(status: boolean) {
    this.localStorageService.setItem(this.COMPACT_ROWS, status.toString());
    this.isCompact$.next(status);
  }

  getStatus() {
    return this.isCompact$.asObservable();
  }

  getStatusValue() {
    return this.isCompact$.value;
  }
}
